import { useMemo } from 'react';

import { ApplianceModel, FilterOption } from '@common/models';
import {
    filterAllEntries,
    getSelectedFiltersMap,
    initializeFiltersOptions,
} from '@core/components/filters/filterUtils';
import { useAppSelector } from '@redux/hooks';
import { CookingApplianceFilters, selectCookingApplianceFilters } from '@redux/slices/cookingApplianceSlice';

import useCookingAppliance from './useCookingAppliance';

type useFilteredCookingAppliancesReturn = {
    filteredCookingAppliances: ApplianceModel[];
    cookingApplianceFilters: CookingApplianceFilters;
};

// TODO: consolidte with useFilteredSinks
const useFilteredCookingAppliances = (): useFilteredCookingAppliancesReturn => {
    const { browsedCookingAppliances } = useCookingAppliance();
    const _cookingApplianceFilters = useAppSelector(selectCookingApplianceFilters);

    const initialFilterOptions: CookingApplianceFilters = useMemo(() => {
        let initialFilters: CookingApplianceFilters = {};
        const setCookingApplianceFilters = (val: CookingApplianceFilters) => {
            initialFilters = val;
        };
        if (browsedCookingAppliances.length > 0) {
            initializeFiltersOptions(browsedCookingAppliances, setCookingApplianceFilters);
        }
        return initialFilters;
    }, [browsedCookingAppliances]);

    const cookingApplianceFilters = useMemo(() => {
        return _cookingApplianceFilters ?? initialFilterOptions;
    }, [_cookingApplianceFilters, initialFilterOptions]);

    const filteredCookingAppliances = useMemo(() => {
        const selectedFilters: Map<string, FilterOption[]> = getSelectedFiltersMap(cookingApplianceFilters);
        return filterAllEntries(Array.from(selectedFilters.entries()), browsedCookingAppliances);
    }, [cookingApplianceFilters, browsedCookingAppliances]);

    return {
        filteredCookingAppliances,
        cookingApplianceFilters,
    };
};

export default useFilteredCookingAppliances;
